import React, { useState } from 'react';
import './LanguageDropdown.scss';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import Hooks from '../../../hooks';
import Icons, { TIcons } from '../../../assets/icons';
import { useTranslation } from 'react-i18next';
import visibleOnRelease from '../../../config/visibleOnRelease';

interface ILanguageOption {
  code: string;
  icon: TIcons;
}

const languageOptions: ILanguageOption[] = [
  {
    code: 'cs',
    icon: 'CzechFlag',
  },
  {
    code: 'en',
    icon: 'EnglandFlag',
  },
  {
    code: 'pl',
    icon: 'PolandFlag',
  },
  {
    code: 'sk',
    icon: 'SlovakiaFlag',
  },
].filter(
  (lang) => lang.code !== (visibleOnRelease.czechLang ? '' : 'cs')
) as ILanguageOption[];

const LanguageDropdown = () => {
  const { i18n } = useTranslation();

  const [isExpanded, setIsExpanded] = useState(false);
  const [language, setLanguage] = useState(i18n.resolvedLanguage);

  const triggerDropdown = () => setIsExpanded((prev) => !prev);

  const dropdownRef = Hooks.useOutsideClick({
    shouldWatch: isExpanded,
    callback: triggerDropdown,
  });

  const listClassName = `berg-components-language-dropdown-list ${
    isExpanded ? 'visible' : ''
  }`;

  const onLanguageSelect = (lang: string) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    triggerDropdown();
    window.location.reload();
  };

  const IconPl = Icons[languageOptions[2].icon];
  const IconEn = Icons[languageOptions[1].icon];
  const IconSk = Icons[languageOptions[3].icon];
  const IconCs = Icons[languageOptions[0].icon];

  return (
    <div className="berg-components-language-dropdown" ref={dropdownRef}>
      <button
        type="button"
        aria-expanded={isExpanded ? 'true' : 'false'}
        onClick={triggerDropdown}
      >
        {languageOptions.find(
          (l: any) => l.code === 'pl' && language === 'pl'
        ) && <IconPl />}
        {languageOptions.find(
          (l: any) => l.code === 'en' && language === 'en'
        ) && <IconEn />}
        {languageOptions.find(
          (l: any) => l.code === 'sk' && language === 'sk'
        ) && <IconSk />}
        {languageOptions.find(
          (l: any) => l.code === 'cs' && language === 'cs'
        ) && <IconCs />}

        {isExpanded ? <FaCaretUp /> : <FaCaretDown />}
      </button>
      <ul className={listClassName}>
        {languageOptions.map((option, index) => {
          const Icon = Icons[option.icon];
          const className = [
            'berg-components-language-dropdown-list-item',
            option.code === language ? 'selected' : '',
          ].join(' ');

          return (
            <li
              className={className}
              key={index}
              onClick={() => onLanguageSelect(option.code)}
            >
              <Icon />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default LanguageDropdown;
